import { render, staticRenderFns } from "./OrdersExport.vue?vue&type=template&id=ac352222&scoped=true"
import script from "./OrdersExport.vue?vue&type=script&lang=js"
export * from "./OrdersExport.vue?vue&type=script&lang=js"
import style0 from "./OrdersExport.vue?vue&type=style&index=0&id=ac352222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac352222",
  null
  
)

export default component.exports